import React, { useState } from "react";
import Analytics from "./analytics";
import Calender from "./calender";
import { ref, getDatabase, get } from "firebase/database";
import { toastrError } from "../components/toastr";

const inputClass =
  "w-full px-4 py-3 bg-gray-50 rounded-xl border border-gray-200 outline-none text-sm text-gray-900 focus:border-primary";

function ExportTab() {
  const ownerId = localStorage.getItem("ownerId");
  const [date, setDate] = useState(() => new Date().toISOString().slice(0, 10));
  const [exporting, setExporting] = useState(false);
  const db = getDatabase();

  async function handleExport() {
    setExporting(true);
    try {
      const snap = await get(ref(db, "customers"));
      if (!snap.exists()) {
        toastrError("No data to export");
        setExporting(false);
        return;
      }
      const all = Object.values(snap.val());
      const [y, m, d] = date.split("-").map(Number);
      const dayStart = new Date(y, m - 1, d, 0, 0, 0, 0);
      const dayEnd   = new Date(y, m - 1, d, 23, 59, 59, 999);
      const email = localStorage.getItem("email");
      const rows = all.filter((c) => {
        if (c.email !== email && c.ownerId !== ownerId) return false;
        const ts = new Date(c.timeStamp).getTime();
        return ts >= dayStart.getTime() && ts <= dayEnd.getTime();
      });
      if (rows.length === 0) {
        toastrError("No customers found for this date");
        setExporting(false);
        return;
      }
      const headers = ["Token#", "Name", "Guests", "Category", "Status", "Mobile", "Table", "Notes", "Time"];
      const csvRows = rows.map((r) =>
        [r.tokenNumber || "", r.userName || "", r.numberOfPeople || "", r.category || "",
         r.status || "", r.mobileNumber || "", r.tableNumber || "",
         (r.notes || "").replace(/,/g, ";"),
         r.timeStamp ? new Date(r.timeStamp).toLocaleTimeString() : ""]
          .map((v) => `"${v}"`).join(",")
      );
      const csv = [headers.join(","), ...csvRows].join("\n");
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `waitlessq-${date}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toastrError("Export failed");
    }
    setExporting(false);
  }

  return (
    <div className="max-w-md mx-auto px-5 pt-6">
      <h1 className="text-2xl font-bold text-gray-900">Export</h1>
      <p className="text-sm text-gray-500 mt-1 mb-5">Download customer data as CSV</p>
      <div className="bg-white rounded-2xl shadow-card border border-gray-100 p-5 flex flex-col gap-4">
        <div>
          <label className="text-xs font-medium text-gray-500 mb-1 block">Select date</label>
          <input
            type="date"
            value={date}
            max={new Date().toISOString().slice(0, 10)}
            onChange={(e) => setDate(e.target.value)}
            className={inputClass}
          />
        </div>
        <button
          onClick={handleExport}
          disabled={exporting}
          className="w-full py-3 rounded-xl font-semibold text-sm bg-primary text-white disabled:opacity-60"
        >
          {exporting ? "Exporting…" : "Download CSV"}
        </button>
      </div>
    </div>
  );
}

const TABS = [
  { id: "analytics", label: "Analytics" },
  { id: "calendar", label: "Calendar" },
  { id: "export",   label: "Export" },
];

function Report() {
  const [tab, setTab] = useState("analytics");

  return (
    <div>
      {/* Sticky sub-tab bar */}
      <div className="sticky top-0 z-10 bg-white border-b border-gray-200">
        <div className="max-w-md mx-auto flex pr-12">
          {TABS.map((t) => (
            <button
              key={t.id}
              onClick={() => setTab(t.id)}
              className={`flex-1 py-3 text-sm font-semibold border-b-2 transition-colors ${
                tab === t.id
                  ? "border-primary text-primary"
                  : "border-transparent text-gray-400"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {tab === "analytics" && <Analytics />}
      {tab === "calendar"  && <Calender />}
      {tab === "export"    && <ExportTab />}
    </div>
  );
}

export default Report;
